var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('van-tabbar',{attrs:{"route":""}},[_c('van-tabbar-item',{attrs:{"to":"/home","icon":"scan"}},[_vm._v("扫码使用")]),_c('van-tabbar-item',{attrs:{"to":"/batch","icon":"guide-o"}},[_vm._v("批量开启")]),_c('van-tabbar-item',{attrs:{"to":"/user","icon":"user-o"}},[_vm._v("我的")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }